import { FieldWrapper } from '@progress/kendo-react-form';
import { Label } from '@progress/kendo-react-labels';
import { Input,Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { Grid, GridColumn, GridNoRecords, GridCellProps } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { PageContext } from './PageContext';
import { useContext,useState, useEffect } from 'react';
import { docLinks } from './Configuration';
import { DocLinks } from '../services/interfaces';
import { SubmitPickupInfo } from './InfoBoxes';
import { PickupList } from './FormComponents';
import { SubmissionContext } from './SubmissionFormContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTrash} from '@fortawesome/free-solid-svg-icons';
import { ConfirmDialog,AlertDialog } from './ConfirmDialog';
import { getAdCreated } from '../services/apiService';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
function PickupForm(){

    const subContext=useContext(SubmissionContext);
    const pageContext=useContext(PageContext);


    const allowMultiPickup =pageContext?.glSettings.AllowMultiPickup;
    const allowAllCustomer =pageContext?.glSettings.AllowPickupFromAllCustomers;
    const [pickupSelection, setPickupSelection]=useState({})
    const [adsForPickup, setAdsForPickup] = useState<any[]>([]);
    const [showConfirm, setShowConfirm]=useState(false);
    const [showAlert, setShowAlert]=useState(false);
    const [adCreated, setAdCreated]=useState(false);
    const [alertTitle,setAlertTitle]=useState("");
    const [alertMessage,setAlertMessage]=useState("");
    const [overwriteWarn, setOverwriteWarn]=useState(false);
    const [showPickupExpire, setShowPickupExpire]= useState(false);
    const pwcChange=(check:CheckboxChangeEvent)=>{
        if (check.target.value){
            subContext?.setSubmitForm(prevObject=>({...prevObject,pickupWithChanges:true}));
        }else{
            subContext?.setSubmitForm(prevObject=>({...prevObject,pickupWithChanges:false}));
        }
    }
    
    const addPickup = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.preventDefault();
        var pickupLimit=1;
        if (allowMultiPickup){pickupLimit=5}
        console.log(pickupSelection);
        if (Object.keys(pickupSelection).length>0){
            if (adsForPickup.length<pickupLimit){
                //under the max number of pickups
                if (showConfirm && adCreated){
                    setShowConfirm(true);
                    
                }else{
                    insertAdForPickup();
                }      
            }else{
                setPickupSelection({});
                setAlertTitle("Pickup Limit");
                setAlertMessage("You have reached the maximum number of pickups for this ad type");
                setShowAlert(true);
            }
        }else{
            setAlertTitle("Select Ad");
            setAlertMessage("Please select an ad from the list");
            setShowAlert(true);
        }


        //console.log(pickupSelection);
    }

    const insertAdForPickup=()=>{
        let adArray = adsForPickup;
        adArray.push(pickupSelection);
        setAdsForPickup(adArray);
        setPickupSelection({});
        let pickupString = "[";
        let count=0;
        adArray.forEach(element => {
            if (count>0){
                pickupString+=",";
            }
            pickupString+="\""+element.element+"\"";
            count++;
        });
        pickupString+="]"
        subContext?.setSubmitForm(prevObject=>({...prevObject,pickup:pickupString}));
    }


    const setPickupExpire=(item:DropDownListChangeEvent)=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,pickupExpire:item.value}));
    }

    const setPickupExpireDate=(item:DatePickerChangeEvent)=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,pickupExpireDate:item.value}));
    }

    const deletePickup=(dataItem:{element:string, customer:string,firstRun:string})=>{
        let adArray = adsForPickup;
        let newArray:any[] = []
        adArray.forEach(element => {
            if (element.element!=dataItem.element){
                newArray.push(element);
            }
        });
        setAdsForPickup(newArray);
        let pickupString = "";
        newArray.forEach(element => {
            pickupString+=element.element + ",";
        });
        subContext?.setSubmitForm(prevObject=>({...prevObject,pickup:pickupString}));
    }

    const deleteButton=(props: GridCellProps)=>{
        return (
            <td>
                <Button fillMode={"flat"} onClick={() => deletePickup(props.dataItem)}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
                </Button>
            </td>
        )
    }

    const overwriteWarning=()=>{
        const showOverwriteWarning = pageContext?.glSettings.OverwriteWarningOnPickupNoChange;
        //console.log("Show overwrite warning: " + showOverwriteWarning);
        const element=pageContext?.selectedAd.element||"";
        if (element!=""){
            getAdCreated(element).then(data=>{
                const adCreated = data.toString();
                setAdCreated(adCreated);
                //console.log("Ad created:" + adCreated);
            });
        }
    }

    const confirmOverwrite=()=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,pickupWithChanges:true}));
        insertAdForPickup();
    }

    const cancelOverwrite=()=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,pickupWithChanges:false}));
    }

    const closeAlert=()=>{
        setShowAlert(false);
    }



    useEffect(() => {
        overwriteWarning();
        console.log(pageContext?.glSettings);
        
    }, []);
    return(
        <div>    
            <h5 className='mb-2'>PICKUP FROM:</h5>
            <SubmitPickupInfo/>
            <FieldWrapper className='mb-2 mt-3'>
                <Checkbox label='No changes required' onChange={pwcChange} checked={subContext?.submitForm.pickupWithChanges}/>
            </FieldWrapper>
        
            <FieldWrapper>
                <Label className='mb-2'>Pickup from:</Label>
                <PickupList value={pickupSelection} setPickup={setPickupSelection} sameCust={false}/>
            </FieldWrapper>

            <Button onClick={addPickup}>Add Pickup</Button>
            <FieldWrapper>
                <Label className='mb-2'>Selected for pickup:</Label>
                <Grid data={adsForPickup} dataItemKey='element'>
                    <GridNoRecords>No ads selected for pickup</GridNoRecords>
                    <GridColumn
                        width={60}
                        field='element'
                        title='&nbsp;'
                        cells={{data:deleteButton}}
                    />
                    <GridColumn title='Ad #' field='element'/>
                    <GridColumn title='Customer' field='customer'/>
                    <GridColumn title='First Run' field='firstRun'/>
                </Grid>
            </FieldWrapper>
            {pageContext?.glSettings.ShowPickupExpiration==="True" ?
                <FieldWrapper>
                    <Label className='mb-2'>Does your ad have an expiration date that needs to be adjusted?</Label>
                    <DropDownList
                        id="pickupDates"
                        className='formField'
                        data={[
                            { text: "Change to Date of Book", value: "BOOK" },
                            { text: "Change to Specific Date", value: "DATE" },
                            { text: "No expiration date", value: "NO" }
                        ]}
                        textField='text'
                        dataItemKey='value'
                        fillMode={"outline"}
                        value={subContext?.submitForm.pickupExpire}
                        onChange={setPickupExpire}
                    />
                </FieldWrapper>
            :null}
            {subContext?.submitForm.pickupExpire.value=="DATE"?
                <FieldWrapper>
                    <Label className='mb-2'>Select the expiration date:</Label>
                    <DatePicker onChange={setPickupExpireDate} fillMode={"outline"} value={subContext?.submitForm.pickupExpireDate? new Date(subContext.submitForm.pickupExpireDate):null}/>
                </FieldWrapper>
            :null}
            {showConfirm?<ConfirmDialog type="WARN" title='WARNING' message='A document already exists for this ad. Initiating a pickup will overwrite the existing ad document. Are you sure you want to continue?' confirmButtonText='Yes' cancelButtonText='No' onConfirm={confirmOverwrite} onClose={cancelOverwrite}   ></ConfirmDialog>:null}
            {showAlert?<AlertDialog type = "WARN" title={alertTitle} message={alertMessage} confirmButtonText='Ok' onClose={closeAlert} ></AlertDialog>:null}
        </div>
    )

}


export const SubmitPickup=(
    //const pageContext = useContext(PageContext);
    //console.log(pageContext);
    <PickupForm/>
)
